(function () {
  function resolveSrc(src) {
    if (!src) return src;
    try {
      return new URL(src, window.location.href).href;
    } catch (e) {
      return src;
    }
  }

  function updateVariantUrl(productUrl, variantId) {
    if (!productUrl) return;
    var path = productUrl + (variantId ? '?variant=' + variantId : '');
    window.history.replaceState({}, '', path);
  }

  function setThumbImage(thumb, src) {
    var img = thumb.querySelector('img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.sizes = '';
    img.src = resolveSrc(src);
  }

  function applyMediaToThumb(thumb, media) {
    thumb.dataset.mediaId = media.id;
    thumb.dataset.src = media.src;
    if (media.srcset) {
      thumb.dataset.srcset = media.srcset;
    } else {
      delete thumb.dataset.srcset;
    }
    thumb.dataset.alt = media.alt || '';
    setThumbImage(thumb, media.thumbSrc || media.src);
  }

  function showMainFromData(main, media) {
    if (!media || !media.src) return;
    if (main.dataset.currentMediaId === media.id) return;

    main.dataset.currentMediaId = media.id;
    main.classList.add('opacity-40');
    main.removeAttribute('srcset');

    var resolvedSrc = resolveSrc(media.src);
    var loadId = (main._galleryLoadId = (main._galleryLoadId || 0) + 1);
    var loader = new Image();
    loader.onload = function () {
      if (loadId !== main._galleryLoadId) return;
      main.src = resolvedSrc;
      if (media.srcset) {
        main.srcset = media.srcset;
      } else {
        main.removeAttribute('srcset');
      }
      main.alt = media.alt || '';
      main.classList.remove('opacity-40');
    };
    loader.onerror = function () {
      if (loadId !== main._galleryLoadId) return;
      main.classList.remove('opacity-40');
      delete main.dataset.currentMediaId;
    };
    loader.src = resolvedSrc;
  }

  function showMain(main, thumb) {
    var mediaId = thumb.getAttribute('data-media-id');
    if (!mediaId) return;

    showMainFromData(main, {
      id: mediaId,
      src: thumb.dataset.src,
      srcset: thumb.dataset.srcset,
      alt: thumb.dataset.alt || '',
    });
  }

  function mediaFromVariantInput(input) {
    if (!input) return null;
    var mediaId = input.getAttribute('data-featured-media-id');
    if (!mediaId) return null;

    return {
      id: mediaId,
      src: input.getAttribute('data-featured-src'),
      srcset: input.getAttribute('data-featured-srcset'),
      alt: input.getAttribute('data-featured-alt') || '',
      thumbSrc: input.getAttribute('data-featured-thumb-src'),
    };
  }

  function getCheckedVariantInput(picker) {
    if (!picker) return null;
    return picker.querySelector('input[name="id"]:checked');
  }

  function updateAddToCartButton(form, input) {
    if (!form || !input) return;
    var submit = form.querySelector('[type="submit"][name="add"]');
    if (!submit) return;
    var available = input.getAttribute('data-available') === 'true';
    submit.disabled = !available;
    submit.textContent = available ? 'Add to cart' : 'Sold out';
  }

  function initGallery(root) {
    var main = root.querySelector('[data-product-gallery-main]');
    if (!main) return;

    var thumbs = root.querySelectorAll('[data-product-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMain(main, thumb);
      });
    });

    var pickerId = root.getAttribute('data-variant-picker');
    if (!pickerId || !root.hasAttribute('data-variant-gallery')) return;

    var variantPicker = document.getElementById(pickerId);
    if (!variantPicker) return;

    var productUrl = root.getAttribute('data-product-url');
    var primaryThumb = root.querySelector('[data-product-gallery-primary-thumb]');

    function applySelectedVariant(input, updateUrl) {
      if (!input) return;

      if (updateUrl) {
        updateVariantUrl(productUrl, input.value);
      }

      updateAddToCartButton(variantPicker.closest('form'), input);

      var media = mediaFromVariantInput(input);
      if (!media) return;

      if (primaryThumb) {
        applyMediaToThumb(primaryThumb, media);
        showMain(main, primaryThumb);
      } else {
        showMainFromData(main, media);
      }
    }

    variantPicker.addEventListener('change', function (event) {
      if (event.target.name !== 'id') return;
      applySelectedVariant(event.target, true);
    });

    var initial = getCheckedVariantInput(variantPicker);
    if (initial) {
      applySelectedVariant(initial, false);
    }
  }

  function initVariantPicker(picker) {
    var productUrl = picker.getAttribute('data-product-url');
    var productForm = picker.closest('form');

    function onSelect(input, updateUrl) {
      if (!input) return;
      if (updateUrl) {
        updateVariantUrl(productUrl, input.value);
      }
      updateAddToCartButton(productForm, input);
    }

    picker.addEventListener('change', function (event) {
      if (event.target.name !== 'id') return;
      onSelect(event.target, true);
    });

    var initial = getCheckedVariantInput(picker);
    if (initial) {
      onSelect(initial, false);
    }
  }

  function init() {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var gallery = document.querySelector(
        '[data-variant-picker="' + picker.id + '"][data-product-gallery]'
      );
      if (!gallery) {
        initVariantPicker(picker);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
